import { SolanaWithSignerBaseCommand } from '../../../solana';
import { CHECK_ICON } from '../../../utils';

import { Flags } from '@oclif/core';
import { parseRawMrEnclave, SwitchboardSecrets } from '@switchboard-xyz/common';
import nacl from 'tweetnacl';

export default class SecretsAddMrEnclave extends SolanaWithSignerBaseCommand {
  static enableJsonFlag = true;

  static description = '';

  static examples = [
    'sb solana secrets add-mrenclave --mrEnclave a4e00d5ef4d89e046aa134f9930069f261268574b6e7f3e48dad963d86cbbffb --secret FFF_MAINNET_SERVICE_RPC_URL --keypair ~/.config/solana/id.json',
  ];

  static flags = {
    ...SolanaWithSignerBaseCommand.flags,
    // Metadata
    mrEnclave: Flags.string({
      char: 'm',
      required: true,
      description: '',
    }),
    secret: Flags.string({
      required: true,
      description: 'name of the secret(s) to add the MrEnclave measurement to',
      multiple: true,
    }),
  };

  async run() {
    const { flags } = await this.parse(
      this.constructor as typeof SecretsAddMrEnclave
    );

    const secrets = flags.secret ?? [];
    if (secrets.length === 0) {
      this.error('At least one secret must be provided');
    }

    const mrEnclave = parseRawMrEnclave(flags.mrEnclave, false);
    const mrEnclaveEncoded = Buffer.from(mrEnclave).toString('hex');

    const sbSecrets = new SwitchboardSecrets();
    const request = sbSecrets.createAddMrEnclaveRequest(
      this.keypair!.publicKey.toBase58(),
      'ed25519',
      mrEnclaveEncoded,
      secrets
    );

    const signature = nacl.sign.detached(
      new Uint8Array(request.toEncodedMessage()),
      this.keypair!.secretKey
    );

    await sbSecrets.addMrEnclave(
      request,
      Buffer.from(signature).toString('base64')
    );

    this.log(`${CHECK_ICON}MrEnclave added to secret(s)`);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async catch(error: any) {
    super.catch(error, 'failed to add MrEnclave to secret{s}');
  }
}
